/** @jsxImportSource @emotion/react */
import React from "react";
import { useSwitchNetwork } from "wagmi";
import { NETWORK_NAME_TO_DISPLAY } from "../../../../config/consts";
import { GlobalStore } from "../../../../store/global/GlobalStore";

export interface NetworkRowProps {
  networkName: string;
  icon: React.ReactNode;
  networkId: number;
}

export const NetworkRow: React.FC<NetworkRowProps> = props => {
  const { switchNetwork } = useSwitchNetwork();
  const theme = GlobalStore.useState(s => s.theme);
  return (
    <>
      <div
        className="row g-0 pointer"
        style={{
          background: theme.surface.main.secondary.default,
          borderRadius: "12px",
          padding: "12px",
          fontFamily: theme.fontFamilies.Primary,
          fontSize: theme.fontSize["5"],
          fontWeight: theme.fontWeights["work-sans-2"],
        }}
        onClick={() => switchNetwork?.(props.networkId)}
      >
        <div className="d-flex align-items-center justify-content-center">
          {props.icon}
          <span className="ms-3">{NETWORK_NAME_TO_DISPLAY[props.networkId]}</span>
        </div>
      </div>
    </>
  );
};
